export default __webpack_public_path__ + "static/media/howto.ec7217d8.jpg";